import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import EnableDisableModal from "../../components/modals/enableDisableModal";
import EnabledDisabledPopUp from "../../components/popups/EnabledDisabledPopUp";
import { enableDisableDistributor } from "../../redux/actions/distributorActions";
import ErrorPopup from "../../components/popups/ErrorPopup";
import TableSendMailModal from "../../components/modals/Distributor/send-mail-table-modal";

const DistributorTableData = ({
  data,
  index,
  distributorListFunc,
  is_subscribed,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [enabledDisable, setEnabledDisable] = useState(false);
  const [onEnableShow, setOnEnableShow] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [sendMailShow, setSendMailShowShow] = useState(false);

  const [userData, setUserData] = useState(null);
  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Distributor" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  const enableDisableFunc = (distributor_id) => {
    console.log(distributor_id);
    dispatch(
      enableDisableDistributor(
        distributor_id,
        onEnableDisableSuccess,
        onEnableDisableError
      )
    );
  };

  const onEnableDisableSuccess = (data) => {
    console.log(data);
    setOnEnableShow(false);

    setEnabledDisable(true);

    const timeOutFnc = () => {
      setEnabledDisable(false);
      distributorListFunc();
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onEnableDisableError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <tr className="table-rows1">
      <td className="table-each-row-data">{index + 1}</td>
      <td className="table-each-row-data">
        {data?.distributor?.distributor_id
          ? data?.distributor?.distributor_id
          : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.distributor?.firm_name
          ? data?.distributor?.firm_name.charAt(0).toUpperCase() +
            data?.distributor?.firm_name.slice(1)
          : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.distributor?.state?.name ? data?.distributor?.state?.name : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.distributor?.city?.name ? data?.distributor?.city?.name : "--"}
      </td>
      {/* <td className="table-each-row-data">
        {data?.distributor?.distributorDivision?.vendorDivision?.name}
      </td> */}
      <td className="table-each-row-data">
        {data?.distributor?.mobile ? data?.distributor?.mobile : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.distributor?.email ? data?.distributor?.email : "--"}
      </td>
      <td className="table-each-row-data text-center">
        {data?.distributor?.pendingOrder.length
          ? data?.distributor?.pendingOrder.length
          : "--"}
      </td>
      <td className="table-each-row-data text-center">
        {data?.distributor?.totalOrders ? data?.distributor?.totalOrders : "--"}
      </td>
      {data?.distributor?.status ? (
        <td className="table-each-row-data color-green">Active</td>
      ) : (
        <td className="table-each-row-data color-danger">Inactive</td>
      )}

      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(`/distributors/onboarded/view/${data.distributor_id}`)
            }
          >
            {"view"}
          </button>

          {(user_type == "super_user" && userData?.write) ||
          user_type == "vendor" ? (
            <>
              <span className="vr  vr_line mt-1 "></span>
              {data?.distributor?.status ? (
                <button
                  className="button-disable"
                  type="button"
                  // bgColor={"red"}
                  color={"green"}
                  onClick={() => setOnEnableShow(true)}
                >
                  DISABLE
                </button>
              ) : (
                <button
                  className="button-enable"
                  type="button"
                  // bgColor={"red"}
                  color={"green"}
                  onClick={() => setOnEnableShow(true)}
                >
                  Enable
                </button>
              )}
            </>
          ) : (
            ""
          )}
        </div>
      </td>
      <EnableDisableModal
        show={onEnableShow}
        title={`Distributor - ${data?.distributor?.distributor_id}`}
        handleClose={() => setOnEnableShow(false)}
        status={data?.distributor?.status}
        id={data?.distributor_id}
        enableDisableFunc={enableDisableFunc}
      />
      <EnabledDisabledPopUp
        title={`Distributor - ${data?.distributor?.distributor_id}`}
        show={enabledDisable}
        status={data.status}
      />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      <TableSendMailModal
        data={data}
        show={sendMailShow}
        distributorListFunc={distributorListFunc}
        handleClose={() => setSendMailShowShow(false)}
      />
    </tr>
  );
};

export default DistributorTableData;
